import { Button } from '@UILayer/Inputs/Button';
import cn from 'classnames';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

//TYPES
import { DOM_ID } from '@UILayer/UILayer.types';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { getMenuButtonActive, setMenuPages } from '@Managers/Redux/AppState/AppState';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';

// IMAGES
import icon from './icon_menu.svg';

const MenuButton: React.FC<{}> = (data) => {
    const [state, setState] = useReducer((state: { active: boolean }, newState: any) => ({ ...state, ...newState }), { active: true });

    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const gameStoreMenuButtonActive = useAppSelector(getMenuButtonActive);
    const btnCN = cn(styles.square_btn, styles.standard_btn, styles.settings_btn, !state.active ? styles.disabled : '');

    useEffect(() => {
        setState({ active: gameStoreMenuButtonActive });
    }, [gameStoreMenuButtonActive]);

    function buttonAction() {
        if (state.active) {
            dispatch(setMenuPages(true));
        }
    }

    return (
        <Button id={DOM_ID.BUTTON_MENU_PAGES} description={t('WCA_OPEN_MENU_PANEL')} className={btnCN} onChange={buttonAction}>
            <img src={icon} alt={t('WCA_OPEN_MENU_PANEL')} />
        </Button>
    );
};

export default MenuButton;
